import React from "react";
import { AppBar, Box, Toolbar } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectUser } from "../../store/slice/user";
import { IMAGES } from "../../theme";
import CustomButton from "../CustomButton";
import { Style } from "./style";

// Nav used on About / Pricing / How It Works / Contact Sales — matches
// new-design's sub-page <nav> exactly (logo + text nav-links + "Back to
// Home"), distinct from the homepage's hamburger + 2-button nav.
const SubPageNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { language } = useSelector(selectUser);
  const isArabic = language === "ar";

  const links = [
    { label: t("marketing.nav.howItWorks"), path: "/how-it-works" },
    { label: t("marketing.nav.pricing"), path: "/pricing" },
    { label: t("marketing.nav.about"), path: "/about" },
    { label: t("marketing.nav.contactSales"), path: "/contact-sales" },
  ];

  return (
    <>
      <Box sx={Style.spacer} />
      <AppBar position="fixed" sx={Style.appBar}>
        <Toolbar sx={{ ...Style.toolbar, flexDirection: isArabic ? "row-reverse" : "row" }}>
          <Box component="img" src={IMAGES.LogoIcon} sx={Style.logoImg} onClick={() => navigate("/")} />
          <Box sx={Style.navLinks(isArabic)}>
            {links.map((l) => (
              <Box key={l.path} sx={Style.navLink(isArabic, pathname === l.path)} onClick={() => navigate(l.path)}>
                {l.label}
              </Box>
            ))}
          </Box>
          <CustomButton
            onClick={() => navigate("/")}
            sx={Style.backButton(isArabic)}
            buttonText={t("marketing.nav.backToHome")}
            color="secondary"
          />
        </Toolbar>
      </AppBar>
    </>
  );
};

export default SubPageNav;
